import { Box, Skeleton } from '@mui/material';

export const DotSeparatedSkeleton = () => {
  return <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
    <Skeleton variant="rounded" width={80} height={12} />
    <Skeleton variant="circular" width={4} height={4} sx={{ margin: '0 6px' }} />
    <Skeleton variant="rounded" width={60} height={12} />
  </Box>
}